import React from 'react';
import { FaAngleRight } from 'react-icons/fa6';

import Button, { ButtonAppearance } from '../../../../../ui/Atoms/Button';
import CollapseMenu from '../../../../../ui/Molecules/CollapseMenu';
import { HeaderSection } from '../HeaderSection';

import * as S from './WebsiteNavigationMobile.styles';

export const WebsiteNavigationMobile = ({ websiteDropdowns }) => {
  return (
    <>
      {websiteDropdowns.map(
        ({ title, sections, moreLink, moreLabel }, index) => {
          if (!title || !sections) return null;

          const hasMoreButton = !!moreLink.url && !!moreLabel;
          const headerSections = sections || [];

          return (
            <CollapseMenu key={`website-${index}`} title={title}>
              {headerSections.length > 0 && (
                <S.MobileSectionWrapper>
                  {headerSections.map((section, index) => (
                    <HeaderSection
                      key={index}
                      section={section}
                      hasMoreButton={hasMoreButton}
                    />
                  ))}
                </S.MobileSectionWrapper>
              )}
              {moreLink.url && moreLabel && (
                <S.MoreButtonWrapper>
                  <Button
                    appearance={ButtonAppearance.MINIMAL}
                    link={moreLink.url}
                    target={moreLink.target}
                  >
                    {moreLabel}
                    <FaAngleRight />
                  </Button>
                </S.MoreButtonWrapper>
              )}
            </CollapseMenu>
          );
        }
      )}
    </>
  );
};
